var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCopyIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 9.25h-6.749a1.5 1.5 0 00-1.5 1.5v6.75a1.5 1.5 0 001.5 1.5h6.75a1.5 1.5 0 001.5-1.5v-6.75a1.5 1.5 0 00-1.5-1.5z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 13.75H5.5a1.5 1.5 0 01-1.5-1.5V5.5A1.5 1.5 0 015.5 4h6.75a1.5 1.5 0 011.5 1.5v.75",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE3LjUwMDkgOS4yNTAxMkgxMC43NTFDOS45MjI1NSA5LjI1MDEyIDkuMjUwOTggOS45MjE2OSA5LjI1MDk4IDEwLjc1MDFWMTcuNTAwMUM5LjI1MDk4IDE4LjMyODUgOS45MjI1NSAxOS4wMDAxIDEwLjc1MSAxOS4wMDAxSDE3LjUwMDlDMTguMzI5NCAxOS4wMDAxIDE5LjAwMDkgMTguMzI4NSAxOS4wMDA5IDE3LjUwMDFWMTAuNzUwMUMxOS4wMDA5IDkuOTIxNjkgMTguMzI5NCA5LjI1MDEyIDE3LjUwMDkgOS4yNTAxMloiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNNi4yNDk5OSAxMy43NUg1LjQ5OTk5QzUuMTAyMTcgMTMuNzUgNC43MjA2NCAxMy41OTE5IDQuNDM5MzQgMTMuMzEwNkM0LjE1ODAzIDEzLjAyOTMgNCAxMi42NDc4IDQgMTIuMjVWNS40OTk5OUM0IDUuMTAyMTcgNC4xNTgwMyA0LjcyMDY0IDQuNDM5MzQgNC40MzkzNEM0LjcyMDY0IDQuMTU4MDMgNS4xMDIxNyA0IDUuNDk5OTkgNEgxMi4yNUMxMi42NDc4IDQgMTMuMDI5MyA0LjE1ODAzIDEzLjMxMDYgNC40MzkzNEMxMy41OTE5IDQuNzIwNjQgMTMuNzUgNS4xMDIxNyAxMy43NSA1LjQ5OTk5VjYuMjQ5OTkiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K";
export { ForwardRef as ReactComponent };